module.exports = {
    /**
     * 浏览器标题
     */
    title: "后台管理",
    /**
     * 3396
     * 端口
     */
    port: 9528,
    /**
     * baseURL前缀
     */
    // baseURL: 'http://192.168.5.66:2060/zhkj_admin',
    baseURL: "https://sys-service.meappstore.top/zhkj_admin",

    /**
     * 公司
     */
    companyType: "changShaYouYou"
};
